var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.selectGroups,"label":"소속그룹","outlined":"","dense":"","value":_vm.groups,"multiple":"","hide-details":""},on:{"change":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }